import { ComponentProps } from "react";
import { FormattedMessage } from "react-intl";
import DocumentCheckIcon from "@/common/svg/document-check.svg";
import GuardIcon from "@/common/svg/guard-cheked.svg";
import PencilIcon from "@/common/svg/pencil.svg";
import SendBoxIcon from "@/common/svg/send-box.svg";
import { FeatureCard, FeatureCardProps } from "@/shared/ui/FeatureCard";
import { twCn } from "@/styles/utils";

const features: FeatureCardProps[] = [
  {
    key: "1",
    Icon: <PencilIcon />,
    title: <FormattedMessage defaultMessage="Подписание" />,
    text: <FormattedMessage defaultMessage="С помощью облачной ЭЦП" />,
  },
  {
    key: "2",
    Icon: <GuardIcon />,
    title: <FormattedMessage defaultMessage="Подтверждение" />,
    text: <FormattedMessage defaultMessage="Через пароль по SMS" />,
  },
  {
    key: "3",
    Icon: <SendBoxIcon />,
    title: <FormattedMessage defaultMessage="Отправка" />,
    text: <FormattedMessage defaultMessage="Документов на e-mail" />,
  },
  {
    key: "4",
    Icon: <DocumentCheckIcon />,
    title: <FormattedMessage defaultMessage="Проверки" />,
    text: (
      <FormattedMessage defaultMessage="ЕНБЕК, Сервис доходов, ГБДФЛ, БМГ, КБ" />
    ),
  },
];

export function Steps(props: ComponentProps<"ul">) {
  return (
    <ul
      {...props}
      className={twCn(
        "lgc:gap-4 lgc:grid-cols-2 grid flex-1 gap-2",
        props.className,
      )}
    >
      {features.map((feature: FeatureCardProps) => (
        <FeatureCard key={feature.key} {...feature} as="li" />
      ))}
    </ul>
  );
}
